import type { QualificationModel } from "./QualificationModel";
import type { QualificationItem } from "./Qualification.typed";

export class QualificationAdapter {
  constructor(private model: QualificationModel) {}

  async getQualificationsList(): Promise<string[]> {
    return this.model.getQualificationsList();
  }

  async listQualificationItems(): Promise<QualificationItem[]> {
    return this.model.listQualificationItems();
  }

  async createQualificationItem(payload: {
    sigle: string;
    name?: string;
    description?: string;
  }): Promise<QualificationItem> {
    return this.model.createQualificationItem(payload);
  }

  async updateQualificationItem(
    id: number,
    payload: { sigle: string; name?: string; description?: string },
  ): Promise<QualificationItem> {
    return this.model.updateQualificationItem(id, payload);
  }

  async deleteQualificationItem(id: number): Promise<void> {
    return this.model.deleteQualificationItem(id);
  }
}
